<template>
  <div class="modern-form-container">
    <v-sheet color="grey lighten-4" class="px-6 py-4 border-bottom">
      <div class="d-flex align-center">
        <v-icon color="primary" class="mr-3">
          {{ id > -1 ? 'fas fa-edit' : 'fas fa-plus-circle' }}
        </v-icon>
        <div>
          <div class="text-h6 font-weight-bold lh-1">
            {{ id > -1 ? 'Actualizar Rubro' : 'Nuevo Rubro' }}
          </div>
          <div class="caption grey--text mt-1">Configuración del clasificador de clientes</div>
        </div>
      </div>
    </v-sheet>

    <v-card-text class="pa-6 pt-8">
      <ValidationObserver v-slot="{ handleSubmit }">
        <v-form @submit.prevent="handleSubmit(save)">
          <v-row dense>
            <v-col cols="12">
              <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                <v-text-field 
                  label="Nombre del Rubro" 
                  v-model="item.name" 
                  outlined 
                  dense
                  placeholder="Ej: Alimentos, Tecnología, etc."
                  :error-messages="errors"
                  :loading="loading"
                  hide-details="auto"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-divider class="my-6"></v-divider>

          <div class="d-flex justify-space-between align-center px-2">
            <div>
              <v-btn 
                v-if="id > -1" 
                text 
                color="error" 
                small 
                @click="showConfirmDelete = true"
                :loading="loading"
                class="px-0"
              >
                <v-icon x-small class="mr-1">fas fa-trash-alt</v-icon>
                Eliminar
              </v-btn>
            </div>
            <div class="d-flex">
              <v-btn text small @click="$emit('close')" class="mr-2" :disabled="loading">
                Cancelar
              </v-btn>
              <v-btn 
                type="submit" 
                color="primary" 
                depressed 
                small 
                class="px-6"
                :loading="loading"
              >
                <v-icon x-small class="mr-2">fas fa-save</v-icon>
                Guardar
              </v-btn>
            </div>
          </div>
        </v-form>
      </ValidationObserver>
    </v-card-text>

    <confirm 
      v-if="item" 
      v-model="showConfirmDelete"
      message="¿Confirma eliminar este rubro? Esta operación no se puede deshacer y puede afectar a los clientes vinculados." 
      @ok="deleteItem(item)"
      @cancel="showConfirmDelete = false" 
    />
  </div>
</template>

<script>
import { getRubro, createRubro, updateRubro, deleteRubro } from '@/api/customers'
import notifications from '@/utils/notifications'

export default {
  name: 'RubroCreateUpdate',
  props: ['id'],
  data() {
    return {
      item: { name: '' },
      loading: false,
      showConfirmDelete: false,
    }
  },
  methods: {
    async save() {
      this.loading = true
      try {
        if (this.id > -1) {
          await updateRubro(this.id, { name: this.item.name })
          notifications.showSuccess('Rubro actualizado correctamente')
        } else {
          await createRubro({ name: this.item.name })
          notifications.showSuccess('Rubro creado correctamente')
        }
        await this.$store.dispatch('getRubros')
        this.$emit('updated')
        this.$emit('close')
      } catch (err) {
        notifications.showError('Error al guardar rubro: ' + err)
      } finally {
        this.loading = false
      }
    },
    async get() {
      if (this.id > -1) {
        this.loading = true
        try {
          const res = await getRubro(this.id)
          this.item = res
        } catch (err) {
          notifications.showError('Error cargando rubro: ' + err)
        } finally {
          this.loading = false
        }
      } else {
        this.item = { id: this.id, name: '' }
      }
    },
    async deleteItem(item) {
      this.loading = true
      try {
        await deleteRubro(item.id)
        notifications.showSuccess('Rubro eliminado correctamente')
        await this.$store.dispatch('getRubros')
        this.$emit('updated')
        this.$emit('close')
      } catch (err) {
        notifications.showError('Error al eliminar rubro: ' + err)
      } finally {
        this.loading = false
        this.showConfirmDelete = false
      }
    }
  },
  watch: {
    id: {
      handler: 'get',
      immediate: true
    }
  }
}
</script>

<style scoped>
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.08); }
.lh-1 { line-height: 1.2; }
</style>